<template>
  <div></div>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
  name: 'Vue2MigrationHelper',
  mounted () {
    window.$vue2 = {
      consentMutations: {
        setAggregatedConsents: this.setAggregatedConsents,
        setAggregatedConsentsLoadingStatus: this.setAggregatedConsentsLoadingStatus
      },
      authenticate: this.authenticate,
      promotions: {
        setActivePromotions: this.SET_ACTIVE_PROMOTIONS,
        setAvailablePromotions: this.SET_PROMOTION
      }
    }
  },
  methods: {
    ...mapMutations('modals', [
      'setAggregatedConsents',
      'setAggregatedConsentsLoadingStatus'
    ]),
    ...mapMutations('promotion', [
      'SET_PROMOTION'
    ]),
    ...mapMutations('promotion/activePromotions', [
      'SET_ACTIVE_PROMOTIONS'
    ]),
    ...mapMutations([
      'authenticate'
    ])
  },
  props: {}
}
</script>
